import { Injectable } from '@angular/core';
import { Transaction, Ratio } from '..';

@Injectable({
  providedIn: 'root',
})
export class RatioService {
  constructor() {}

  public getRatiosByCurrency(transactions: Array<Transaction>): Array<Ratio> {
    // Remove duplicates
    const currencies = [...new Set(transactions?.map((t) => t.currency))];

    // return sum associated to currency
    return currencies?.map(
      (currency: string) =>
        ({
          amount: transactions
            .filter((t) => t.currency === currency)
            .reduce((acc, o) => acc + o.amount, 0),
          currency,
        } as Ratio)
    );
  }
}
